module.exports = __webpack_public_path__ + "img/funciones.10a74e10.png";